import { useDispatch } from 'react-redux';
import { useKeycloak } from '@react-keycloak/web';
import { useCallback } from 'react';
import { blockMedia, unblockMedia } from '../../store/reducers/media.reducer';

export const useBlockMedia = () => {
    const dispatch = useDispatch();
    const { keycloak } = useKeycloak();

    const handleBlockMedia = useCallback((mediaPoint) => {
        if (!keycloak.token || !mediaPoint) return;

        if (mediaPoint.status === 'BLOCKED') {
            dispatch(unblockMedia({ mediaId: mediaPoint.id, token: keycloak.token }));
        } else {
            dispatch(blockMedia({ mediaId: mediaPoint.id, token: keycloak.token }));
        }
    }, [dispatch, keycloak.token]);

    return { handleBlockMedia };
};